import Link from 'next/link';
import React, { useState } from 'react'
import { RightChevronSvg } from '../icons/ChevronSvg';


interface Props {
  href: string
}
const LinkWithChevron: React.FC<Props> = ({ href, children }) => {
  return (
    <Link href={href}>
      <div className="flex items-center">
        <a className="dark:text-gray-400 cursor-pointer text-solid-blue">{children}</a>
        <RightChevronSvg className="h-8 w-8 text-solid-blue dark:text-gray-400 stroke-current" />
      </div>
    </Link>
  )
}


export default LinkWithChevron;